import { ca } from '@cian/analytics';

import { FDealType } from '../../utils/category';
import { EPageKind } from '../../types/page';
import { getEventCategoryFromPageKind } from '../../utils/tracking';

export enum ESpecialType {
  /** Do not use */
  Unexpected   = 0,
  /** Оценка */
  Valuation = 1 << 0,
  /** Ипотека */
  Mortgage = 1 << 1,
}

export function trackDealTypeTabClick(pageKind: EPageKind, type: FDealType) {
  const TAB_NAME_MAP = {
    [FDealType.Sale]: 'sale',
    [FDealType.RentLongterm]: 'rent',
    [FDealType.RentDaily]: 'daily',
  };

  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'Click',
    label: `Tab/${TAB_NAME_MAP[type] || 'unexpected'}`,
  });
}

export function trackSpecialTabClick(pageKind: EPageKind, type: ESpecialType) {
  const TAB_NAME_MAP = {
    [ESpecialType.Valuation]: 'calculate',
  };

  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'Click',
    label: `Tab/${TAB_NAME_MAP[type] || 'unexpected'}`,
  });
}
